export enum SampleType {
  image,
  pdf,
  file
}

export enum CandidateStatus {
  new,
  reviewed,
  interview,
  withdrawn,
  rejected,
  filled,
  closed,
  hired,
  unknown,
}

export enum TrackerCandidateStatus {
  new,
  reviewed,
  interviewing,
  offerExtended,
  notInterested,
  unknown
}

export enum TrackerOrderStatus {
  created,
  hasCandidates,
  hasSubmittals,
  interviewing,
  offerExtended,
  offerAccepted
}

export enum InterviewStatus {
  requested,
  scheduled,
  canceled,
  complete,
  unknown
}

export const enum PlacementLengthType {
  days = 1,
  weeks = 2,
  months = 3
}

export interface PersonName {
  firstName: string;
  lastName: string;
}

export function isOrder(obj: any): obj is Order {
  return typeof obj === 'object' && obj !== null && 'placementTypeId' in obj;
}

export function isSubmittal(obj: any): obj is Submittal {
  return typeof obj === 'object' && obj !== null && 'profile' in obj;
}

export enum ActivityType {
  SubmittedToClient = 315,
  InterviewScheduled = 316,
  RejectedByClient = 322,
  AcceptedForOrder = 323,
  ClientInterview = 330,
  ClientInterviewComplete = 363,
  SecondInterviewScheduled = 388,
  SecondInterviewComplete = 389,
  ThirdInterviewScheduled = 390,
  ThirdInterviewComplete = 391,
  InterviewRequested = 593,
  OfferExtended = 618,
  GatherNotInterested = 625,
  ReviewedByClient = 629,
  ReconsideredByClient = 630,
  InterviewCanceled = 631,
}

export const enum OrderStatus {
  Inquiry = 1,
  New = 2,
  PendingApproval = 3,
  Approved = 4,
  Filled = 5,
  OnHold = 6,
  Transferred = 7,
  FilledByCompetitor = 8,
  NoSuitableTalent = 9,
  ClientCancelled = 10,
  EntryMistakeUnqualified = 11,
  FilledByClient = 12,
  PendingOnboarding = 13,
  ClientRequested = 14
}

export const enum Country {
  US = 1,
  Canada = 2,
  Japan = 6,
  France = 5
}

export const enum Market {
  Adelaide = 98,
  Alabama = 120,
  AllMarkets = 0,
  Amsterdam = 43,
  AquentDirect = 66,
  AquentHealthcare = 95,
  Arkansas = 122,
  Atlanta = 23,
  AtlantaIT = 823,
  Auckland = 54,
  Austin = 60,
  AustinIT = 860,
  Bangalore = 110,
  Barcelona = 87,
  Beijing = 106,
  Boise = 102,
  Boston = 10,
  BostonApprentice = 52,
  BostonIT = 810,
  Brisbane = 56,
  Calgary = 77,
  CedarRapids = 880,
  CedarRapidsCRE = 80,
  Charlotte = 61,
  CharlotteIT = 861,
  ChicagoIT = 814,
  ChicagoMetro = 14,
  ChicagoSuburbs = 42,
  Cleveland = 32,
  ClevelandIT = 832,
  ConnecticutSouthern = 34,
  ConnecticutSouthernIT = 834,
  CST = 65,
  Dallas = 22,
  DallasIT = 822,
  Denver = 27,
  DenverIT = 827,
  DesMoines = 804,
  DesMoinesCRE = 28,
  Detroit = 24,
  DetroitIT = 824,
  Dublin = 74,
  EastBayWalnutCreekCA = 882,
  EastBayWalnutCreekCACRE = 82,
  Eastlake = 107,
  ExeterNH = 809,
  Frankfurt = 67,
  Fukuoka = 92,
  Germany = 115,
  GreensboroNCCRE = 21,
  Hamburg = 103,
  HongKong = 90,
  Houston = 826,
  HoustonCRE = 26,
  Indianapolis = 58,
  IndianapolisIT = 858,
  JobsInCreation = 97,
  Johannesburg = 105,
  KansasCity = 805,
  KansasCityCRE = 5,
  Kentucky = 116,
  KualaLumpur = 99,
  LAPasadena = 71,
  LasVegas = 69,
  LAWoodlandHills = 70,
  London = 29,
  LongIsland = 45,
  LongIslandIT = 845,
  LosAngeles = 13,
  LosAngelesIT = 813,
  Louisiana = 117,
  Lyon = 114,
  ManchesterUK = 48,
  Maryland = 46,
  MarylandIT = 846,
  Melbourne = 36,
  Minneapolis = 20,
  MinneapolisIT = 820,
  Mississippi = 118,
  MolineIl = 807,
  MolineIlCRE = 62,
  Montreal = 57,
  Mumbai = 91,
  Munich = 49,
  Nagoya = 79,
  Nashville = 63,
  NashvilleIT = 863,
  NewJersey = 30,
  NewJerseyIT = 830,
  NewYork = 11,
  NewYorkIT = 811,
  Oklahoma = 119,
  Omaha = 806,
  OmahaCRE = 6,
  OrangeCountyCA = 19,
  OrangeCountyCAIT = 819,
  Orlando = 72,
  OrlandoIT = 872,
  Osaka = 64,
  Paris = 35,
  Pensacola = 121,
  Perth = 100,
  Philadelphia = 18,
  PhiladelphiaIT = 818,
  Phoenix = 31,
  PhoenixIT = 831,
  Pittsburgh = 38,
  PittsburghIT = 838,
  PortlandOR = 41,
  PortlandORIT = 841,
  Prague = 86,
  PriceJamieson = 109,
  Providence = 73,
  Raleigh = 879,
  RaleighCRE = 8,
  RaleighDurhamRTP = 803,
  ReadingUK = 55,
  RichmondVA = 78,
  RichmondVAIT = 878,
  RitaSueLondon = 76,
  RitaSueNewYork = 75,
  RoboHead = 88,
  Sacramento = 59,
  SacramentoIT = 859,
  SanDiego = 16,
  SanDiegoIT = 816,
  SanFrancisco = 12,
  SanFranciscoIT = 812,
  SantaAnaIT = 93,
  Sapporo = 108,
  Seattle = 17,
  SeattleIT = 817,
  Seoul = 89,
  Shanghai = 101,
  SiliconValley = 15,
  SiliconValleyIT = 815,
  Singapore = 50,
  SingaporeIT = 850,
  SouthFlorida = 33,
  SouthFloridaIT = 802,
  SpainTemp = 111,
  StLouis = 37,
  StLouisIT = 837,
  Stockholm = 53,
  Sydney = 39,
  Taipei = 113,
  Tampa = 68,
  TampaIT = 868,
  Tokyo = 44,
  TokyoMarcom = 94,
  Toronto = 40,
  Vancouver = 47,
  VirginiaNorthern = 51,
  VirginiaNorthernIT = 825,
  VMS = 96,
  Warsaw = 104,
  WashingtonDC = 25,
  WashingtonDCIT = 851,
  Wisconsin = 881,
  WisconsinCRE = 81
}

export enum TimecardRateType {
  HOURLY = 1,
  DAILY = 2
}

export const enum AccountType {
  Personal = 1,
  Enterprise = 2,
  TimecardOnly = 3
}

export enum TimecardStatus {
  Submitted = 1,
  Draft = 2,
  Signed = 3,
  Approved = 4,
  Disputed = 5
}

export enum SubmittalFeedbackType {
  independentAssessment = 'independent-assessment',
  qcc = 'qcc',
  outsideReview = 'outside-review',
  summary = 'summary'
}

export enum LocationPreference {
  onSite = 'on-site',
  offSite = 'off-site',
  noPreference = 'no-preference',
  default = 'default'
}

export enum PlacementType {
  temp = 'temp',
  tempToPerm = 'temp-to-perm',
  perm = 'permanent'
}

export enum EndOfAssignmentEventType {
  updated = 'end_of_assignment_updated',
  dismissed = 'end_of_assignment_dismissed',
  deferred = 'end_of_assignment_deferred'
}

export enum DiversityOptions {
  gender = 'gender',
  ethnicity = 'ethnicity',
  neurodiversity = 'neurodiversity',
  disability = 'disability',
  veteran = 'veteran',
  lgbtqia = 'lgbtqia'
}

export enum DiversityFunnelStages {
  applied = 'Applied',
  submitted = 'Submitted',
  rejected = 'Rejected',
  interviewed = 'Interviewed',
  offerextended = 'Offer Extended',
  hired = 'Hired'
}

export enum DiversityColors {
  orange = '#EB591A',
  blue = '#0084BF',
  green = '#4C9A2E',
  purple = '#6929C4',
  brown = '#B88400',
  blueGray = '#458390',
  red = '#9C0000',
  black = '#212121',
  gray = '#CBCBCB',
  notAsLightGray = '#D0D0D0',
}

export interface DiversityDemographicDataByStage {
  label: string;
  percentage: number;
  count: number;
  color: string;
  notEnoughData?: boolean;
}

export interface DiversityDemographicData {
  label: string;
  data: DiversityDemographicDataByStage[];
}

export interface DiversityData {
  year: number;
  quarter: string;
  hidden: boolean;
  orderCount: number;
  entireNotEnoughData: boolean;
  data: DiversityDemographicData[];
}

export interface DiversityTab {
  name?: String;
  data: DiversityData[];
}

export interface DiversityLegendClickEvent {
  label: string;
  checked: boolean;
  isStage: boolean;
}

export interface FunnelSelectionDetails {
  selectedFunnelStage: string;
  selectedYear: number;
  selectedQuarter: number;
}
